import styled from 'styled-components';

type Props = {
  margin?: string;
};

type VerticalProps = {
  height?: string;
};

export const Separator = styled.div<Props>`
  width: 100%;
  height: 1px;
  margin: ${(p) => (p.margin ? p.margin : '44px 0')};
  border: none;
  background-color: ${(p) => p.theme.colors.stroke};
  position: relative;
`;

export const VerticalSeparator = styled.div<VerticalProps>`
  width: 1px;
  min-width: 1px;
  height: ${(p) => (p.height ? p.height : '100%')};
  background-color: ${(p) => p.theme.colors.stroke};
`;
